import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// react-snap prerenders the app into static HTML at build time. When that
// markup is present we hydrate it (attach React to existing DOM) for a faster,
// SEO-friendly first paint; otherwise we render fresh as usual.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
